// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610120737/js/" + chunkId + "." + {"44":"cc40610e","225":"840e0d33","481":"72f802dc","486":"ef2eb1a2","770":"c1285227"}[chunkId] + ".0.9393517502843612.chunk.js";
};